import { useEffect, useRef } from 'react';

// Wraps a "load more" callback so a second invocation can't fire while the
// first is still in flight (80431 PR feedback) — e.g. two rapid clicks
// bumping a page counter twice before React has even re-rendered with the
// updated loading flag. A ref is required rather than state: it must block
// the very next call synchronously, without waiting on a render, so it also
// holds even for two calls made back-to-back in the same tick (no render in
// between at all).
export const useLoadMoreGuard = (isLoading) => {
  const isPending = useRef(false);

  useEffect(() => {
    if (!isLoading) {
      isPending.current = false;
    }
  }, [isLoading]);

  return (callback) => () => {
    if (isPending.current) return;
    isPending.current = true;
    callback();
  };
};
